import { STORE_EASY_ACCESS_TOKEN } from 'apps/detention-review/utils/actions/accessToken'

interface IAccessTokenAction {
  type: string
  token: string
}

export interface IAccessTokenState {
  token: string | undefined
}

const defaultState = {
  token: undefined,
}

export const accessTokenReducer = (
  state: IAccessTokenState = defaultState,
  action: IAccessTokenAction
): IAccessTokenState => {
  switch (action.type) {
    case STORE_EASY_ACCESS_TOKEN: {
      const { token } = action
      return {
        ...state,
        token,
      }
    }
    default:
      return state
  }
}
